import PropTypes from "prop-types";
import QuaternaryButton from "shared/components/inputs/button/QuaternaryButton";
import React from "react";
import { DividerLine, DividerText, DividerWrapper } from "./JobsDivider.styles";

const JobsDivider = ({ isExpanded, count, onClick }) => {
    return (
        <DividerWrapper onClick={onClick}>
            <QuaternaryButton
                leadingIcon={isExpanded ? "caret-down" : "caret-right"}
                {...{
                    "aria-label": isExpanded ? "Hide" : "Show more",
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            />
            <DividerText>
                {isExpanded ? "Hide" : `Show ${count} more`}
            </DividerText>
            <DividerLine />
        </DividerWrapper>
    );
};

JobsDivider.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    count: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default JobsDivider;
